import $ from 'jquery';
import 'bootstrap/js/tooltip';
import 'bootstrap/js/transition';
import 'bootstrap/js/collapse';

$('[data-toggle="tooltip"]').tooltip({
  container: 'body',
});

$('.bootstrap-accordion-title').each(function fixCollapsedClass() {
  const $this = $(this);
  const $body = $this.closest('.panel').find('.panel-collapse.collapse');
  $this.toggleClass('collapsed', !$body.hasClass('in'));
});

$('.accordion-parent').on('show.bs.collapse', '.panel', function onShown() {
  const $panel = $(this).closest('.panel');
  $('html, body').animate({
    scrollTop: $panel.offset().top,
  }, {
    duration: 350,
    step: (now, tween) => {
      tween.end = $panel.offset().top;
    },
  });
});

// FIX FOR HEADER HIERARCHY
(function accordionFix() {
  // fix nested accordions due to editor bug
  const $panels = $('.accordion-parent > .bootstrap-accordion > .bootstrap-accordion');
  $.each($panels, (i, panel) => {
    const $panel = $(panel);
    $panel.parent().parent().append($panel);
  });

  function fixAccordionHeading() {
    const $h3 = $('<h3>', {
      html: $(this).html(),
      class: $(this).attr('class'),
    });

    // Copy all data attributes
    $.each($(this).data(), (key, value) => {
      $h3.attr(`data-${key}`, value);
    });

    return $h3;
  }

  function fixAccordionButton() {
    const $button = $('<button>', {
      html: $(this).html(),
      class: $(this).attr('class'),
    });

    // Copy all data attributes
    $.each($(this).data(), (key, value) => {
      $button.attr(`data-${key}`, value);
    });
    // Copy href to data-target
    $button.attr('data-target', $(this).attr('href'));

    return $button;
  }

  // fix all existing accordions
  $('.accordion-parent .panel-heading h4').replaceWith(fixAccordionHeading);
  $('.accordion-parent .panel-heading h3 a').replaceWith(fixAccordionButton);

  // observe for new accordions
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // some accordions are added dynamically and if they have the "collapsing" class
      // are not initialized yet, so wait until they are

      if (mutation.type === 'childList') {
        const $addedNodes = $(mutation.addedNodes);
        const $accordions = $addedNodes.find('.accordion-parent .panel-heading h4');
        if ($accordions.length) {
          $accordions.find('a').each(function eachClass() {
            const cls = $(this).attr('class').split(/\s+/);
            if (!cls.includes('collapsing')) {
              $(this).parent().replaceWith(fixAccordionHeading);
            }
          });
        }
        const $accordionButtons = $addedNodes.find('.accordion-parent .panel-heading a');
        if ($accordionButtons.length) {
          $accordionButtons.each(function eachClass() {
            const cls = $(this).attr('class').split(/\s+/);
            if (!cls.includes('collapsing')) {
              $(this).replaceWith(fixAccordionButton);
            }
          });
        }
      }
      if (mutation.type === 'attributes') {
        if (mutation.target.matches('.accordion-parent .panel-heading h4 a')) {
          const cls = $(mutation.target).attr('class').split(/\s+/);
          if (!cls.includes('collapsing')) {
            $(mutation.target).parent().replaceWith(fixAccordionHeading);
            requestAnimationFrame(() => {
              $('.accordion-parent .panel-heading h3 a').replaceWith(fixAccordionButton);
            });
          }
        }
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true });
}());

// FIX FOR LANDING BOX HOVER ANIMATION
(function fixLandingBoxHeaderHover() {
  $('.landing-box .caption h2, .landing-box .caption h3, .landing-box .caption h4, .document').each(function wrapSpan() {
    // wrap in a span
    const $this = $(this);
    const $span = $('<span>', {
      html: $this.html(),
    });
    $this.empty();
    $this.append($span);
  });
}());

// replace old iframe chart embed urls
// (this only happens if page/chart was not edited since new urls were introduced)
$('iframe[src^="https://danesjenovdan.si/grafi/embed.html"]').each(function eachFrame() {
  this.src = this.src.replace('https://danesjenovdan.si/grafi/embed.html', '/charts/embed.html');
});
$('iframe[src^="https://other.lb.djnd.si/grafi/embed.html"]').each(function eachFrame() {
  this.src = this.src.replace('https://other.lb.djnd.si/grafi/embed.html', '/charts/embed.html');
});

// add title to chart iframes for accessibility
$('iframe[src*="charts/embed.html"]').each(function eachFrame() {
  if (!this.title) {
    this.title = 'Grafikon';
  }
});



// WEBPACK FOOTER //
// ./src/article.js